import * as React from "react";
import { forwardRef } from "react";
const SvgStatisticsicon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "currentcolor", "data-token-category": "Navigation", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0.888889 14.3333H5.04267V7.22222H0.888889V14.3333ZM5.93156 14.3333H10.0684V1.88889H5.93156V14.3333ZM10.9573 14.3333H15.1111V9H10.9573V14.3333ZM0 15.2222V6.33333H5.04267V1H10.9573V8.11111H16V15.2222H0Z" }));
const ForwardRef = forwardRef(SvgStatisticsicon);
export default ForwardRef;
